var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _path, _g, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _path2, _path3, _path4, _polygon33, _polygon34, _path5, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _path6, _polygon45, _polygon46, _path7, _path8, _polygon47, _path9, _path10, _polygon48, _path11, _polygon49, _path12, _path13, _path14, _polygon50, _path15, _path16, _path17, _path18, _path19, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNjMasthead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 514.79 224.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#e);}.f{fill:url(#f);}.g{fill:url(#g);}.h{fill:url(#h);}.i{fill:url(#i);}.j{fill:url(#j);}.k{fill:url(#k);}.l{fill:url(#l);}.m{fill:url(#m);}.n{fill:url(#n);}.o{fill:url(#o);}.p{fill:url(#p);}.q{fill:url(#q);}.r{fill:url(#r);}.s{fill:url(#s);}.t{fill:url(#t);}.u{fill:url(#u);}.v{fill:url(#v);}.w{fill:url(#w);}.x{fill:url(#x);}.y{fill:url(#y);}.z{fill:url(#z);}.aa{fill:url(#aa);}.ab{fill:url(#ab);}.ac{fill:url(#ac);}.ad{isolation:isolate;}.ae{clip-path:url(#ae);}.af{fill:url(#ag);}.ag{fill:url(#ah);}.ah{fill:url(#ai);}.ai{fill:url(#aj);}.aj{fill:url(#ak);}.ak{fill:url(#al);}.al{fill:url(#am);}.am{fill:url(#an);}.an{fill:url(#ao);}.ao{fill:url(#ap);}.ap{fill:url(#aq);}.aq{fill:url(#ar);}.ar{fill:url(#as);}.as{fill:url(#at);}.at{fill:url(#au);}.au{fill:url(#av);}.av{fill:url(#aw);}.aw{fill:url(#ax);}.ax{fill:url(#ay);}.ay{fill:url(#az);}.az{fill:url(#ba);}.ba{fill:url(#bb);}.bb{fill:url(#bc);}.bc{fill:url(#bd);}.bd{fill:url(#be);}.be{fill:url(#bf);}.bf{fill:url(#bg);}.bg{fill:url(#bh);}.bh{fill:url(#bi);}.bi{fill:url(#bj);}.bj{fill:url(#bk);}.bk{fill:url(#bl);}.bl{fill:url(#bm);}.bm{fill:url(#bn);}.bn{fill:url(#bo);}.bo{fill:url(#bp);}.bp{fill:url(#bq);}.bq{fill:url(#br);}.br{fill:url(#bs);}.bs{fill:url(#bt);}.bt{fill:url(#bu);}.bu{fill:url(#bv);}.bv{clip-path:url(#bx);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 265.92,
    y1: 137.34,
    x2: 287.73,
    y2: 127.99,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 43.77, -52.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#290000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#450405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8c0e12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e41b23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 52.03,
    y1: 342.09,
    x2: 126.62,
    y2: 342.09,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 462.25,
    y1: 91.48,
    x2: 506.11,
    y2: 78.47,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 450.9,
    y1: 169.65,
    x2: 487.28,
    y2: 169.65,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 403.11,
    y1: 109.66,
    x2: 461.8,
    y2: 80.62,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 400.51,
    y1: 95.03,
    x2: 500.2,
    y2: 75.3,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 429.53,
    y1: 178.57,
    x2: 495.83,
    y2: 178.57,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 477.16,
    y1: 255.29,
    x2: 558.86,
    y2: 255.29,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 365.64,
    y1: 84.1,
    x2: 397.79,
    y2: 84.1,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 365.63,
    y1: 111.07,
    x2: 393.58,
    y2: 111.07,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 448.81,
    y1: 267.4,
    x2: 484.22,
    y2: 267.4,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 440.37,
    y1: 263.36,
    x2: 470.48,
    y2: 260.76,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 417.46,
    y1: 227.08,
    x2: 448.1,
    y2: 220.33,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 380.73,
    y1: 164.7,
    x2: 409.01,
    y2: 164.7,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 369.04,
    y1: 150.81,
    x2: 407.98,
    y2: 136.27,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 413.57,
    y1: 258.2,
    x2: 457.38,
    y2: 258.2,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 415.53,
    y1: 256.43,
    x2: 440.97,
    y2: 256.43,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 338.95,
    y1: 144.6,
    x2: 369.63,
    y2: 144.6,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 385.9,
    y1: 282.31,
    x2: 421.03,
    y2: 282.31,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 385.9,
    y1: 233.85,
    x2: 408.99,
    y2: 233.85,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 335,
    y1: 194.5,
    x2: 371,
    y2: 194.5,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 309.11,
    y1: 149.47,
    x2: 352.25,
    y2: 149.47,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 278.34,
    y1: 135.85,
    x2: 313.85,
    y2: 135.85,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 360.62,
    y1: 287.98,
    x2: 398.32,
    y2: 287.98,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 299.2,
    y1: 196.24,
    x2: 315.95,
    y2: 196.24,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 319.38,
    y1: 218.7,
    x2: 352.25,
    y2: 218.7,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 334.45,
    y1: 277.73,
    x2: 382.53,
    y2: 265.32,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 271.37,
    y1: 166.66,
    x2: 302.08,
    y2: 166.66,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 280,
    y1: 177.57,
    x2: 304.83,
    y2: 177.57,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae",
    transform: "translate(-31.34 -91.12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M260.57,130.36l17.28-7.17c.65-.27,1.33-.5,2-.71s1.4-.37,2.13-.51,1.48-.23,2.25-.3,1.56-.1,2.37-.11c1.39,0,2.73.06,4,.17s2.55.28,3.75.5a33,33,0,0,1,3.46.85,26.57,26.57,0,0,1,3.17,1.19,12.45,12.45,0,0,1,2.69,1.61,9.73,9.73,0,0,1,2,2.11,9.89,9.89,0,0,1,1.31,2.62,13,13,0,0,1,.62,3.12l-17.65,7a12.74,12.74,0,0,0-.61-3.08A9.74,9.74,0,0,0,288.1,135a9.88,9.88,0,0,0-2-2.07,12.14,12.14,0,0,0-2.66-1.58,25.89,25.89,0,0,0-3.13-1.17,32.85,32.85,0,0,0-3.42-.83c-1.19-.22-2.42-.38-3.7-.49s-2.61-.16-4-.15c-.8,0-1.58,0-2.34.1a22.38,22.38,0,0,0-2.22.31,20.28,20.28,0,0,0-2.11.5A19.54,19.54,0,0,0,260.57,130.36Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 316.96,
    y1: 257.65,
    x2: 341.29,
    y2: 257.65,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 256.81,
    y1: 164.53,
    x2: 281.21,
    y2: 159.34,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 283.51,
    y1: 254.85,
    x2: 326.39,
    y2: 254.85,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 284.49,
    y1: 254.66,
    x2: 327.38,
    y2: 254.66,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 282.85,
    y1: 254.34,
    x2: 326.39,
    y2: 254.34,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 309.69,
    y1: 300.48,
    x2: 344.69,
    y2: 300.48,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 219.65,
    y1: 164.28,
    x2: 300.81,
    y2: 164.28,
    gradientTransform: "matrix(0.99, 0.19, -0.19, 0.99, 43, -53.11)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 253.39,
    y1: 228.46,
    x2: 282.99,
    y2: 259.62,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 273.18,
    y1: 282.36,
    x2: 288.24,
    y2: 279.76,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 197.94,
    y1: 223.48,
    x2: 233.41,
    y2: 223.48,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 172.6,
    y1: 123.07,
    x2: 231.6,
    y2: 285.41,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 212.47,
    y1: 266.89,
    x2: 292.69,
    y2: 266.89,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 137.51,
    y1: 129.78,
    x2: 162.31,
    y2: 233.5,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 218.12,
    y1: 321.96,
    x2: 252.56,
    y2: 321.96,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 212.59,
    y1: 318.66,
    x2: 235.95,
    y2: 312.95,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 192.37,
    y1: 276.95,
    x2: 215.22,
    y2: 276.43,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 179.6,
    y1: 312.57,
    x2: 223.3,
    y2: 312.57,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 98.9,
    y1: 206.94,
    x2: 169.65,
    y2: 206.94,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 170.21,
    y1: 310.9,
    x2: 194.61,
    y2: 310.9,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 148.47,
    y1: 287.42,
    x2: 169.66,
    y2: 287.42,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 148.46,
    y1: 338.46,
    x2: 182.53,
    y2: 338.46,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 94.72,
    y1: 246.02,
    x2: 129.73,
    y2: 246.02,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 65.44,
    y1: 233.91,
    x2: 126.82,
    y2: 233.91,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 52.03,
    y1: 322.91,
    x2: 80.97,
    y2: 322.91,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 531.47,
    y1: 226.39,
    x2: 380.7,
    y2: -2.33,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec00f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fcbd0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f6b50f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#eca60f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#de9110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cc7610"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#b55511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#a74011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#a94411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#c36f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d99407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#eab004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#f5c402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fdd000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 463.6,
    y1: 271.13,
    x2: 312.83,
    y2: 42.41,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 43.77, -52.45)",
    xlinkHref: "#be"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 406.82,
    y1: 308.56,
    x2: 256.04,
    y2: 79.84,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 43.77, -52.45)",
    xlinkHref: "#be"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 332.94,
    y1: 357.26,
    x2: 182.17,
    y2: 128.55,
    xlinkHref: "#be"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 333.89,
    y1: 356.63,
    x2: 183.12,
    y2: 127.92,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 43.77, -52.45)",
    xlinkHref: "#be"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 240.12,
    y1: 418.45,
    x2: 89.35,
    y2: 189.73,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 43.77, -52.45)",
    xlinkHref: "#be"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 506.93,
    y1: 261.32,
    x2: 480.3,
    y2: 142.2,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 12.43, -143.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02a8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#088bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0f7197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#145b77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#19485b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#1d3945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#202d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#222529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#232022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 437.07,
    y1: 200.56,
    x2: 540.76,
    y2: 200.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e88324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#e98624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ea8e25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ed9d25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f2b227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f7cd28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#feee2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff32a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 438.39,
    y1: 276.64,
    x2: 411.75,
    y2: 157.53,
    xlinkHref: "#bk"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 373.37,
    y1: 197.21,
    x2: 465.17,
    y2: 197.21,
    xlinkHref: "#bl"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 334.71,
    y1: 299.82,
    x2: 308.08,
    y2: 180.71,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 43.77, -52.45)",
    xlinkHref: "#bk"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 250.09,
    y1: 203.93,
    x2: 375.64,
    y2: 203.93,
    xlinkHref: "#bl"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 243.49,
    y1: 320.22,
    x2: 216.86,
    y2: 201.1,
    xlinkHref: "#bk"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 206.57,
    y1: 155.12,
    x2: 228.58,
    y2: 155.12,
    xlinkHref: "#bl"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 281.92,
    y1: 311.63,
    x2: 255.28,
    y2: 192.51,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 43.77, -52.45)",
    xlinkHref: "#bk"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    x1: 223.5,
    y1: 254.38,
    x2: 296.16,
    y2: 254.38,
    xlinkHref: "#bl"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: 162.09,
    y1: 338.42,
    x2: 135.45,
    y2: 219.31,
    gradientTransform: "matrix(0.98, 0.19, -0.19, 0.98, 43.77, -52.45)",
    xlinkHref: "#bk"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 48.86,
    y1: 202.47,
    x2: 227.34,
    y2: 202.47,
    xlinkHref: "#bl"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "bx",
    transform: "translate(-31.34 -91.12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.74,309.36l-15.26,4.46q-1.55.45-3.15.81c-1.06.24-2.15.44-3.26.62s-2.24.32-3.38.43-2.32.19-3.51.24a60.49,60.49,0,0,1-8.78-.27,51.16,51.16,0,0,1-8.23-1.55,47.5,47.5,0,0,1-7.66-2.84,49,49,0,0,1-7.08-4.14A32.6,32.6,0,0,1,37,302.41a18.81,18.81,0,0,1-3.24-4.84,22.44,22.44,0,0,1-1.66-5.43,57.53,57.53,0,0,1-.72-6.47l14.46-5a59.26,59.26,0,0,0,.73,6.58,23.2,23.2,0,0,0,1.69,5.52,19.33,19.33,0,0,0,3.29,4.92,32.72,32.72,0,0,0,5.55,4.79,48.73,48.73,0,0,0,7.19,4.21,47.64,47.64,0,0,0,7.77,2.9,51.33,51.33,0,0,0,8.33,1.59,60.86,60.86,0,0,0,8.91.28c1.2-.05,2.39-.13,3.55-.25s2.31-.25,3.43-.43,2.23-.39,3.31-.63S101.69,309.66,102.74,309.36Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NJ_logov2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "475.91 30.06 456.03 36.92 433.3 36.99 452.93 30.1 475.91 30.06"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "459.87 109.05 440.05 114.78 421.63 115.16 441.26 109.4 459.87 109.05"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "434.41 30.15 414.98 37.07 391.81 37.14 410.99 30.19 434.41 30.15"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "410.99 30.2 391.81 37.15 381.13 21.6 400.17 14.4 410.99 30.2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "441.5 109.04 434.41 30.16 414.98 37.08 421.88 114.8 430.24 208.96 450.09 204.62 441.5 109.04"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "514.79 202.01 494.24 206.32 430.24 208.95 450.09 204.61 514.79 202.01"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "371.62 14.33 352.9 21.57 370.64 8.86 389.54 1.45 371.62 14.33"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "j",
    points: "375.05 54.16 356.24 60.81 352.89 21.57 371.61 14.33 375.05 54.16"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "k",
    points: "438.18 205.06 418.45 209.4 401.13 210.11 420.66 205.77 438.18 205.06"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "l",
    points: "420.64 205.77 401.11 210.11 394.35 194.45 413.78 189.87 420.64 205.77"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "m",
    points: "407.09 174.35 387.75 179.19 372.11 143.03 391.22 137.63 407.09 174.35"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "n",
    points: "379.91 110.28 360.95 116.08 357.63 76.57 376.47 70.16 379.91 110.28"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "376.47 70.16 357.63 76.57 329.02 76.91 347.55 70.46 376.47 70.16"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "p",
    points: "413.78 189.87 394.35 194.45 368.08 195.44 387.22 190.84 413.78 189.87"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "q",
    points: "387.22 190.84 368.08 195.44 361.26 184.56 380.3 179.79 387.22 190.84"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "347.51 70.46 328.99 76.91 318.06 61.15 336.43 54.45 347.51 70.46"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "373.31 207.7 354.31 212.06 336.54 212.79 336.54 212.78 355.3 208.42 373.31 207.7"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "t",
    points: "355.27 208.48 336.54 212.78 360.95 116.08 379.89 110.27 355.27 208.48"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "u",
    points: "341 111.32 322.49 117.17 303.12 117.56 321.39 111.69 341 111.32"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "321.88 111.41 303.11 117.59 295.24 21.98 313.51 14.24 321.88 111.41"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "296.1 42.53 278.21 49.47 258.56 49.58 276.21 42.61 296.1 42.53"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "x",
    points: "350 208.62 331.37 213.03 310.58 213.88 328.87 209.47 350 208.62"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "y",
    points: "286.11 105.22 268.26 111.23 268.15 109.86 286 103.82 286.11 105.22"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "z",
    points: "297.34 153.2 279.3 158.47 303.12 117.56 321.88 111.41 297.34 153.2"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "aa",
    points: "328.87 209.47 310.58 213.88 281.01 174.34 299.09 169.32 328.87 209.47"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "ab",
    points: "278.57 71.17 260.85 77.7 245.99 77.87 263.53 71.32 278.57 71.17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M310.58,170.46l-.66-8.18-17.72,6.54.65,8.05a14.33,14.33,0,0,1-.11,3.22,12.25,12.25,0,0,1-.85,3,12.8,12.8,0,0,1-1.59,2.76,16.53,16.53,0,0,1-2.34,2.51c-.46.42-.94.8-1.43,1.17s-1,.69-1.53,1-1.07.6-1.63.86a17.14,17.14,0,0,1-1.72.69h0l17.62-6.18c.59-.21,1.17-.45,1.74-.71s1.11-.55,1.64-.86a18.11,18.11,0,0,0,1.55-1,16.13,16.13,0,0,0,1.45-1.17,17.05,17.05,0,0,0,2.37-2.56,13.48,13.48,0,0,0,1.6-2.79,12.65,12.65,0,0,0,.86-3A14.18,14.18,0,0,0,310.58,170.46Z",
    transform: "translate(-31.34 -91.12)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M260.57,130.36l17.28-7.17c.65-.27,1.33-.5,2-.71s1.4-.37,2.13-.51,1.48-.23,2.25-.3,1.56-.1,2.37-.11c1.39,0,2.73.06,4,.17s2.55.28,3.75.5a33,33,0,0,1,3.46.85,26.57,26.57,0,0,1,3.17,1.19,12.45,12.45,0,0,1,2.69,1.61,9.73,9.73,0,0,1,2,2.11,9.89,9.89,0,0,1,1.31,2.62,13,13,0,0,1,.62,3.12l-17.65,7a12.74,12.74,0,0,0-.61-3.08A9.74,9.74,0,0,0,288.1,135a9.88,9.88,0,0,0-2-2.07,12.14,12.14,0,0,0-2.66-1.58,25.89,25.89,0,0,0-3.13-1.17,32.85,32.85,0,0,0-3.42-.83c-1.19-.22-2.42-.38-3.7-.49s-2.61-.16-4-.15c-.8,0-1.58,0-2.34.1a22.38,22.38,0,0,0-2.22.31,20.28,20.28,0,0,0-2.11.5A19.54,19.54,0,0,0,260.57,130.36Z",
    transform: "translate(-31.34 -91.12)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ae"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M307.65,133.73l-17.65,7a12.74,12.74,0,0,0-.61-3.08A9.74,9.74,0,0,0,288.1,135a9.88,9.88,0,0,0-2-2.07,12.14,12.14,0,0,0-2.66-1.58,25.89,25.89,0,0,0-3.13-1.17,32.85,32.85,0,0,0-3.42-.83c-1.19-.22-2.42-.38-3.7-.49s-2.61-.16-4-.15c-.8,0-1.58,0-2.34.1a22.38,22.38,0,0,0-2.22.31,20.28,20.28,0,0,0-2.11.5,19.54,19.54,0,0,0-2,.7l17.28-7.17c.65-.27,1.33-.5,2-.71s1.4-.37,2.13-.51,1.48-.23,2.25-.3,1.56-.1,2.37-.11c1.39,0,2.73.06,4,.17s2.55.28,3.75.5a33,33,0,0,1,3.46.85,26.57,26.57,0,0,1,3.17,1.19,12.45,12.45,0,0,1,2.69,1.61,9.73,9.73,0,0,1,2,2.11,9.89,9.89,0,0,1,1.31,2.62,13,13,0,0,1,.62,3.12",
    transform: "translate(-31.34 -91.12)"
  }))))), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "af",
    points: "299.52 169.25 280.94 174.34 273.71 174.57 291.58 169.52 299.52 169.25"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "ag",
    points: "263.53 71.33 245.99 77.88 234.75 61.85 252.13 55.04 263.53 71.33"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "ah",
    points: "276.09 211.96 258.23 216.34 250.47 118.62 268.11 112.7 276.09 211.96"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "ai",
    points: "277.09 211.96 259.23 216.34 251.47 118.62 269.11 112.7 277.09 211.96"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "aj",
    points: "276.09 211.96 258.23 216.34 249.99 117.64 268.31 111.69 276.09 211.96"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "ak",
    points: "294.94 210.84 276.65 215.59 258.23 216.34 276.29 211.59 294.94 210.84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M299.33,202.68c-.63.08-1.26.15-1.9.2s-1.29.11-1.94.14-1.32.06-2,.08a54.53,54.53,0,0,1-8.16-.45,47.12,47.12,0,0,1-7.67-1.68,43.92,43.92,0,0,1-7.15-2.91,45.27,45.27,0,0,1-6.64-4.14,42.29,42.29,0,0,1-5.66-5,33.15,33.15,0,0,1-4.2-5.58,28.68,28.68,0,0,1-2.73-6.1,29.78,29.78,0,0,1-1.27-6.64l-2.38-33.1a28.78,28.78,0,0,1,.24-6.72,25.84,25.84,0,0,1,5.33-11.48,28.14,28.14,0,0,1,4.45-4.58c.74-.63,1.84-1.49,2.61-2.06s1.84-1.24,2.66-1.75,1.81-1,2.66-1.45,2.07-.73,3-1.11l-18.39,7c-.87.38-1.73.79-2.57,1.23s-1.66.92-2.47,1.42-1.59,1-2.35,1.6-1.52,1.17-2.25,1.79a33.49,33.49,0,0,0-4.79,5,26.51,26.51,0,0,0-3.28,5.52,25.18,25.18,0,0,0-1.77,6,28.13,28.13,0,0,0-.24,6.52L233,177.08a28.8,28.8,0,0,0,1.25,6.53,28.07,28.07,0,0,0,2.69,6A32.47,32.47,0,0,0,241,195.1a41,41,0,0,0,5.58,5,45.43,45.43,0,0,0,6.56,4.07,43.66,43.66,0,0,0,7.06,2.86,48,48,0,0,0,7.57,1.64,53.29,53.29,0,0,0,8.07.43c.66,0,1.31,0,2-.07l1.92-.15c.63-.05,1.25-.12,1.87-.2s1.23-.17,1.84-.28l17.73-5.95C300.58,202.5,300,202.6,299.33,202.68Z",
    transform: "translate(-31.34 -91.12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M277.64,237.05a17,17,0,0,0-.61-3.31,14.7,14.7,0,0,0-1.27-3,16.35,16.35,0,0,0-1.93-2.76,20.08,20.08,0,0,0-2.61-2.5,21.5,21.5,0,0,0-3.06-2.05,19.79,19.79,0,0,0-3.31-1.45,20,20,0,0,0-3.56-.83,22.58,22.58,0,0,0-3.8-.22c-.56,0-1.1,0-1.64.09s-1.06.11-1.58.2-1,.19-1.52.31-1,.27-1.46.42l-17.08,5.7q.71-.24,1.44-.42c.49-.12,1-.22,1.51-.31s1-.15,1.56-.2,1.07-.08,1.62-.09a23.07,23.07,0,0,1,3.75.21,19.49,19.49,0,0,1,3.51.82,19.72,19.72,0,0,1,3.27,1.42,21,21,0,0,1,3,2,20,20,0,0,1,2.57,2.45,16.51,16.51,0,0,1,1.91,2.72,15,15,0,0,1,1.24,3,15.91,15.91,0,0,1,.6,3.26l.63,8.17,17.44-5.3Z",
    transform: "translate(-31.34 -91.12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M280.18,273.63a15.52,15.52,0,0,0,.08-3.35l-.65-8.31-17.48,5,.64,8.19a15.63,15.63,0,0,1-.08,3.29,13.43,13.43,0,0,1-.78,3.07,14.51,14.51,0,0,1-1.48,2.84,17,17,0,0,1-2.18,2.61,17.88,17.88,0,0,1-3.71,2.83,16.15,16.15,0,0,1-2.09,1,18.28,18.28,0,0,1-2.23.76L267.57,287a18.93,18.93,0,0,0,2.27-.77,16.33,16.33,0,0,0,2.1-1,18,18,0,0,0,2-1.3,20.22,20.22,0,0,0,1.8-1.57,18,18,0,0,0,2.21-2.65,14.94,14.94,0,0,0,1.49-2.89A13.76,13.76,0,0,0,280.18,273.63Z",
    transform: "translate(-31.34 -91.12)"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "ao",
    points: "200.41 113.61 183.6 119.6 163.05 120.01 179.6 114.01 200.41 113.61"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "ap",
    points: "179.6 114.01 163.05 120.01 155.71 21.54 172.05 13.98 179.6 114.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M270.91,303.65c-.73.14-1.48.27-2.23.37s-1.52.2-2.3.27-1.56.12-2.36.15a46.9,46.9,0,0,1-7.64-.31,40.58,40.58,0,0,1-7.18-1.56,39.34,39.34,0,0,1-6.7-2.83,40.89,40.89,0,0,1-6.22-4.09,39.85,39.85,0,0,1-5.32-5,32.81,32.81,0,0,1-4-5.59,30.12,30.12,0,0,1-2.58-6.15,32.16,32.16,0,0,1-1.22-6.72l-2.55-33.66a30.65,30.65,0,0,1,.19-6.73,27.14,27.14,0,0,1,1.64-6.25,28.75,28.75,0,0,1,3.07-5.75,35.28,35.28,0,0,1,4.51-5.26,37.27,37.27,0,0,1,3-2.55,33.72,33.72,0,0,1,3.16-2.2,35,35,0,0,1,3.35-1.83c1.16-.54,2.34-1,3.56-1.46l-17,5.94c-1.2.43-2.37.91-3.51,1.45a34.18,34.18,0,0,0-6.44,4,38.29,38.29,0,0,0-2.93,2.52,33.81,33.81,0,0,0-4.45,5.18,28.3,28.3,0,0,0-3.05,5.67,26.58,26.58,0,0,0-1.62,6.14,31,31,0,0,0-.2,6.63l2.48,33.13a31.64,31.64,0,0,0,1.2,6.61,29.79,29.79,0,0,0,2.54,6.06,32.74,32.74,0,0,0,3.9,5.49,38.69,38.69,0,0,0,5.24,4.93,42,42,0,0,0,6.14,4,39,39,0,0,0,6.61,2.77,39.74,39.74,0,0,0,7.09,1.53,45.74,45.74,0,0,0,7.54.3q1.19,0,2.34-.15c.76-.07,1.52-.16,2.27-.26s1.48-.23,2.2-.37,1.44-.31,2.15-.48l17.44-4.41C272.37,303.35,271.65,303.51,270.91,303.65Z",
    transform: "translate(-31.34 -91.12)"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "ar",
    points: "134.87 79.69 118.92 86.28 114.25 21.59 130.06 13.97 134.87 79.69"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "as",
    points: "200.37 214.63 183.43 219.04 164.28 219.83 180.97 215.41 200.37 214.63"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "at",
    points: "180.95 215.43 164.26 219.84 157.08 203.38 173.65 198.69 180.95 215.43"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "au",
    points: "166.55 181.93 150.09 186.88 133.46 148.87 149.66 143.29 166.55 181.93"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "av",
    points: "173.65 198.69 157.08 203.38 128.02 204.47 144.22 199.77 173.65 198.69"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "aw",
    points: "135.22 114.89 119.23 120.93 74.5 56.26 89.83 49.13 135.22 114.89"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "ax",
    points: "144.22 199.77 128.02 204.47 120.67 193.03 136.76 188.15 144.22 199.77"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "ay",
    points: "108.52 218.35 92.77 222.78 119.24 120.93 135.23 114.89 108.52 218.35"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "az",
    points: "128.48 217.55 112.46 221.97 92.76 222.78 108.51 218.35 128.48 217.55"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "ba",
    points: "94.33 116.04 78.87 122.12 57.42 122.54 72.59 116.44 94.33 116.04"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "M108.88,276l-4.79-68.79,0,0L96.06,91.12l-15,7.94L89,213.26l0,0L93.57,281a14.25,14.25,0,0,1-.16,3.41,13.14,13.14,0,0,1-1,3.18,14.63,14.63,0,0,1-1.78,3,18.82,18.82,0,0,1-2.6,2.71,20,20,0,0,1-1.79,1.4,21.93,21.93,0,0,1-1.91,1.2,21.4,21.4,0,0,1-2,1,22.2,22.2,0,0,1-2.16.79h0L95.3,292.9q1.13-.36,2.19-.81a22,22,0,0,0,2.07-1,21.75,21.75,0,0,0,1.94-1.22,22.13,22.13,0,0,0,1.81-1.42,19.36,19.36,0,0,0,2.63-2.76,15.73,15.73,0,0,0,1.8-3,13.62,13.62,0,0,0,1-3.24A14.67,14.67,0,0,0,108.88,276Z",
    transform: "translate(-31.34 -91.12)"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "bc",
    points: "14.46 189.57 0 194.56 18.06 182.79 32.76 177.63 14.46 189.57"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "bd",
    points: "504.6 186.56 467.28 187.93 460.07 108.67 452.93 30.11 475.91 30.07 474.48 14.51 400.13 14.38 410.95 30.19 434.37 30.14 441.46 109.03 450.05 204.61 514.75 202.01 504.6 186.56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M420.87,92.58,403,105.45l3.45,39.84-38.63.27,11.08,16,28.93-.3,3.46,40.06h0l-24.61,98.22,18-.72,7-27.89L418.56,282l26.57-1,6.86,15.9,17.51-.7L430.36,201Zm-8,173.36,9.48-37.56,15.87,36.72Z",
    transform: "translate(-31.34 -91.12)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M344.85,105.36l8.09,97.08L328.89,244l-7.32.2L317.65,196l.8-.59.78-.62.76-.63.76-.66a34.17,34.17,0,0,0,4.68-5.12,26.86,26.86,0,0,0,3.18-5.58,25.07,25.07,0,0,0,1.68-6,28.21,28.21,0,0,0,.2-6.52l-2-24.38-45,.31,11.39,16.3,15-.16.66,8.18a14.18,14.18,0,0,1-.1,3.27,12.63,12.63,0,0,1-.85,3,13.53,13.53,0,0,1-1.61,2.79,17,17,0,0,1-2.36,2.55,18.29,18.29,0,0,1-2.92,2.15,18.64,18.64,0,0,1-3.28,1.56,21.81,21.81,0,0,1-3.64.95,25.62,25.62,0,0,1-4,.37,27.07,27.07,0,0,1-4.07-.24,22.55,22.55,0,0,1-3.8-.85,21.5,21.5,0,0,1-3.55-1.45,23.13,23.13,0,0,1-3.28-2.07A21.48,21.48,0,0,1,274.3,180a16.85,16.85,0,0,1-2.08-2.77,14.31,14.31,0,0,1-1.35-3,15,15,0,0,1-.63-3.29L267.64,138a14.33,14.33,0,0,1,.11-3.29,12.7,12.7,0,0,1,.88-3,13.3,13.3,0,0,1,1.63-2.78,16.75,16.75,0,0,1,2.4-2.54,18.72,18.72,0,0,1,6.24-3.6,21.28,21.28,0,0,1,3.66-.9,25.74,25.74,0,0,1,4-.31c1.39,0,2.74,0,4,.17s2.55.28,3.75.5a32.4,32.4,0,0,1,3.46.85,27.83,27.83,0,0,1,3.18,1.18,12.87,12.87,0,0,1,2.69,1.61,10,10,0,0,1,2,2.12,10.47,10.47,0,0,1,1.31,2.61,13.67,13.67,0,0,1,.62,3.13l19.88-.09a27.49,27.49,0,0,0-1.25-6.35,24.1,24.1,0,0,0-2.63-5.6,25.78,25.78,0,0,0-4-4.84,32,32,0,0,0-5.42-4.1,49.27,49.27,0,0,0-6.39-3.27,51.1,51.1,0,0,0-6.95-2.34,57.5,57.5,0,0,0-7.5-1.42,68,68,0,0,0-8.07-.48,51.66,51.66,0,0,0-8,.58,42.56,42.56,0,0,0-7.32,1.79,37.81,37.81,0,0,0-12.56,7.19,33.53,33.53,0,0,0-4.82,5.06,26.73,26.73,0,0,0-3.31,5.57,25.65,25.65,0,0,0-1.77,6.09,28.22,28.22,0,0,0-.23,6.59l2.57,33.06a30,30,0,0,0,1.26,6.61,29,29,0,0,0,2.73,6.08,32.29,32.29,0,0,0,4.18,5.55,41.8,41.8,0,0,0,5.63,5,46.43,46.43,0,0,0,6.62,4.13,44.21,44.21,0,0,0,7.13,2.9,47.45,47.45,0,0,0,7.63,1.67,52.86,52.86,0,0,0,8.13.44c.67,0,1.33,0,2-.07s1.3-.08,1.93-.14,1.27-.12,1.9-.21a4.2,4.2,0,0,0,.62-.08l.11.37,8,99.25,18.65-.75-3.36-41.32,7.31-.23,30,40.19,21.13-.85-35.67-48.05,26.87-49.63h0l-4.77-56.5-3.39-40.17Z",
    transform: "translate(-31.34 -91.12)"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "bg",
    points: "200.42 113.64 192.78 14.04 172.05 14.01 179.61 114.04 200.42 113.64"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "bh",
    d: "M299,269.69,279.61,262l.66,8.32a16.2,16.2,0,0,1-.08,3.35,14.34,14.34,0,0,1-.79,3.11,14.07,14.07,0,0,1-1.49,2.88,17,17,0,0,1-2.21,2.66,18.76,18.76,0,0,1-2.74,2.24,18.06,18.06,0,0,1-3.07,1.64,19.38,19.38,0,0,1-3.42,1.05,23.32,23.32,0,0,1-7.58.28,20.41,20.41,0,0,1-3.58-.8A19.5,19.5,0,0,1,252,285.3a19.72,19.72,0,0,1-3.1-2,18.53,18.53,0,0,1-2.64-2.49,16.26,16.26,0,0,1-2-2.79,15.51,15.51,0,0,1-1.29-3.06,16.65,16.65,0,0,1-.6-3.35l-2.58-33.52a15.6,15.6,0,0,1,.09-3.36,13.82,13.82,0,0,1,.81-3.11,14.13,14.13,0,0,1,1.52-2.87,17,17,0,0,1,2.24-2.63,18,18,0,0,1,5.85-3.8,20,20,0,0,1,3.43-1,22.56,22.56,0,0,1,3.75-.39,23.61,23.61,0,0,1,3.8.22,20.75,20.75,0,0,1,3.56.84,20.21,20.21,0,0,1,3.31,1.44,22.25,22.25,0,0,1,3.07,2.06,20,20,0,0,1,2.6,2.49,16.49,16.49,0,0,1,1.94,2.77,15.88,15.88,0,0,1,1.27,3,16.26,16.26,0,0,1,.6,3.31l.65,8.3,18.06-8.79a32.25,32.25,0,0,0-1.21-6.59,30.84,30.84,0,0,0-2.53-6,32.69,32.69,0,0,0-3.86-5.52,40.42,40.42,0,0,0-5.19-5,42.34,42.34,0,0,0-6.1-4.11,39.84,39.84,0,0,0-6.59-2.9,41.5,41.5,0,0,0-7.08-1.68,46.08,46.08,0,0,0-7.59-.46,45.41,45.41,0,0,0-7.52.75,38,38,0,0,0-6.86,2,35.64,35.64,0,0,0-6.21,3.18,37.16,37.16,0,0,0-5.55,4.39,34.15,34.15,0,0,0-4.5,5.26,28,28,0,0,0-3.08,5.75,27.52,27.52,0,0,0-1.64,6.25,31.26,31.26,0,0,0-.19,6.73l2.55,33.65a32.58,32.58,0,0,0,1.22,6.72,30,30,0,0,0,2.59,6.16,31.3,31.3,0,0,0,4,5.58,38.59,38.59,0,0,0,5.31,5,41.39,41.39,0,0,0,6.22,4.09,40.15,40.15,0,0,0,13.88,4.39,47,47,0,0,0,7.64.31,45.09,45.09,0,0,0,7.52-.92,37.93,37.93,0,0,0,6.83-2.11,35.84,35.84,0,0,0,6.13-3.31,37.17,37.17,0,0,0,5.44-4.49,35.12,35.12,0,0,0,4.39-5.31,28.61,28.61,0,0,0,3-5.76,28.26,28.26,0,0,0,1.56-6.21A32,32,0,0,0,299,269.69Z",
    transform: "translate(-31.34 -91.12)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "bi",
    d: "M182.48,105.09l-21.08,0,4.81,65.72L120.92,105,96.05,91.13l8.08,116.06h0l4.79,68.8a14.24,14.24,0,0,1-.16,3.47,13,13,0,0,1-1,3.23,14.56,14.56,0,0,1-1.8,3,19.36,19.36,0,0,1-2.63,2.76,22.3,22.3,0,0,1-3.23,2.34,22.58,22.58,0,0,1-3.61,1.72,24.53,24.53,0,0,1-4,1.1,28.09,28.09,0,0,1-4.4.48,29.5,29.5,0,0,1-4.44-.15,25.51,25.51,0,0,1-4.16-.81A24.44,24.44,0,0,1,72,289.57,21.51,21.51,0,0,1,69,287a16.15,16.15,0,0,1-2.23-2.88,14.49,14.49,0,0,1-2.08-6.65l-.59-8.7L45.79,280.7a56.85,56.85,0,0,0,.74,6.58,22.73,22.73,0,0,0,1.68,5.52,19.64,19.64,0,0,0,3.3,4.92,33.53,33.53,0,0,0,5.54,4.79,48.73,48.73,0,0,0,7.19,4.21,48,48,0,0,0,7.77,2.9,52.32,52.32,0,0,0,8.34,1.58,59.36,59.36,0,0,0,8.9.28,58.2,58.2,0,0,0,8.78-1,48.14,48.14,0,0,0,8-2.22,44.31,44.31,0,0,0,7.21-3.46,43.59,43.59,0,0,0,6.42-4.69,37.8,37.8,0,0,0,5.21-5.53,29.73,29.73,0,0,0,3.57-6,26.74,26.74,0,0,0,1.94-6.44,29.73,29.73,0,0,0,.31-6.9l-4.86-68.49h.06l-4.72-66.54L166.55,206,139.84,309.46l20-.8,8.29-29.39,7.46,11.63L205,289.82l7.3,16.73,19.39-.78L190,205.56ZM169.61,274l11.2-39.58,16.88,38.65Z",
    transform: "translate(-31.34 -91.12)"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "bj",
    points: "437.07 27.19 412.51 27.23 405.73 17.34 471.79 17.45 472.68 27.13 449.7 27.17 464.59 190.98 503.05 189.57 509.42 199.27 452.74 201.55 437.07 27.19"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "M438,109l64.65.11.8,8.68-22.43,0h-.54l0,.54,14.9,163.81,0,.48.47,0,38.18-1.4,5.73,8.72-55.32,2.23L468.91,118.26l-.05-.45h-.45l-24.3,0L438,109m-.95-.5,6.78,9.89,24.56,0,15.67,174.36,56.68-2.28-6.37-9.7-38.46,1.41L481,118.28l23,0-.89-9.67-66.06-.11Z",
    transform: "translate(-31.34 -91.12)"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "bl",
    points: "382.88 110.44 379.14 67.17 349.04 67.48 342.03 57.35 378.27 57.1 374.69 15.75 387.05 6.88 396.12 110.55 433.83 202.31 422.55 202.76 415.7 186.87 388.82 187.86 382.48 177.74 411.35 176.79 390.32 128.12 379.14 172.41 379.13 172.39 370.97 204.84 359.11 205.32 382.88 110.44"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "bm",
    d: "M418,98.91l9,102.8v.07l0,.07L464.43,293l-10.21.41-6.73-15.58-.13-.31H447l-26.59,1-5.72-9.13,28-.93.73,0-.29-.67-21-48.67-.59-1.35-.36,1.43-10.89,43.17,0,0-.28,1.11-8.07,32.09-10.82.44,23.62-94.23,0-.08v-.08L411,158.24l0-.46h-.47l-29.83.31L374.32,149l35.29-.25h.54l0-.54-3.55-41.06,11.4-8.2m.42-.92L406,106.87l3.58,41.34-36.24.26,7,10.13,30.1-.32,3.74,43.28-23.77,94.87,11.86-.47,8.16-32.45v0l11.18-44.29,21,48.66-28.86,1L420.16,279,447,278l6.85,15.89,11.28-.45-37.71-91.77L418.38,98Z",
    transform: "translate(-31.34 -91.12)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "bn",
    d: "M302.6,203.21l-.75-1.14L300.28,200c-.57.1-1.15.18-1.73.26s-1.18.14-1.78.19-1.22.1-1.83.14-1.24.05-1.87.06a49.58,49.58,0,0,1-7.69-.42c-.88-.11-1.74-.26-2.6-.42a42.62,42.62,0,0,1-4.55-1.14,41.88,41.88,0,0,1-6.66-2.71,43.74,43.74,0,0,1-6.2-3.86,39.81,39.81,0,0,1-5.23-4.66,30.22,30.22,0,0,1-3.81-5,26.07,26.07,0,0,1-2.44-5.46,26.66,26.66,0,0,1-1.14-5.95l-2.57-33.07a25.06,25.06,0,0,1,.21-5.9,22.08,22.08,0,0,1,1.56-5.37,23.55,23.55,0,0,1,2.94-5,30.56,30.56,0,0,1,4.4-4.61,34.77,34.77,0,0,1,11.59-6.64,39.75,39.75,0,0,1,6.82-1.66,48.33,48.33,0,0,1,7.55-.55,64,64,0,0,1,7.71.46c1.31.16,2.61.36,3.87.61,1.1.21,2.19.46,3.25.73a48.32,48.32,0,0,1,6.54,2.21,44.13,44.13,0,0,1,6,3.07,29.36,29.36,0,0,1,4.92,3.72,22.42,22.42,0,0,1,3.56,4.29,21.73,21.73,0,0,1,2.32,4.92,24.25,24.25,0,0,1,.66,2.51l-14,.06c-.09-.38-.2-.75-.32-1.1a13,13,0,0,0-4.27-6.11,15.55,15.55,0,0,0-3.32-2,30.55,30.55,0,0,0-3.51-1.31,34.87,34.87,0,0,0-3.59-.89l-.19,0c-1.3-.24-2.65-.42-4-.54s-2.83-.18-4.3-.18a30.52,30.52,0,0,0-4.45.34,25.3,25.3,0,0,0-4.16,1,22.27,22.27,0,0,0-3.81,1.74,21.21,21.21,0,0,0-3.4,2.42,20.13,20.13,0,0,0-2.82,3,16.51,16.51,0,0,0-2,3.4,15.08,15.08,0,0,0-1.08,3.75,16.86,16.86,0,0,0-.14,4l2.6,32.92a17.83,17.83,0,0,0,.75,3.94,17.3,17.3,0,0,0,1.64,3.65,19.3,19.3,0,0,0,2.45,3.26,24,24,0,0,0,3.2,2.85,25.21,25.21,0,0,0,3.7,2.33,24.78,24.78,0,0,0,4,1.65,25.84,25.84,0,0,0,2.82.71c.48.09,1,.17,1.46.24a30.28,30.28,0,0,0,4.51.27,29,29,0,0,0,4.46-.41,24.75,24.75,0,0,0,4.15-1.09,23.06,23.06,0,0,0,3.79-1.79,22,22,0,0,0,3.36-2.49,20.3,20.3,0,0,0,2.77-3,16.62,16.62,0,0,0,2-3.4,16,16,0,0,0,1.05-3.74,17.27,17.27,0,0,0,.12-3.95l-.88-10.92-16.23.17-7.29-10.42,36.66-.25,1.78,21.65a25.67,25.67,0,0,1-.17,5.84,22.76,22.76,0,0,1-1.49,5.34,23.82,23.82,0,0,1-2.84,5,29.89,29.89,0,0,1-4.28,4.67l-.69.61-.71.59-.72.57-.74.55-1.33,1,4.28,52.62,11.75-.33L356,203.12l-7.9-94.81,13.62,0,7.86,93.1-27.35,50.5L375.64,297l-14,.56-30-40.17-12,.37,3.37,41.35-12.74.51Z",
    transform: "translate(-31.34 -91.12)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M285.15,108.71h.1a63.14,63.14,0,0,1,7.65.46c1.3.16,2.6.36,3.84.6,1.09.21,2.17.45,3.21.73a47.87,47.87,0,0,1,6.48,2.18,47.38,47.38,0,0,1,5.94,3,29.4,29.4,0,0,1,4.83,3.66,22.19,22.19,0,0,1,3.49,4.2,20.68,20.68,0,0,1,2.26,4.8c.2.6.37,1.22.52,1.86l-13,.06c-.07-.26-.15-.52-.23-.76a13.51,13.51,0,0,0-4.44-6.34,15.9,15.9,0,0,0-3.43-2,30.25,30.25,0,0,0-3.57-1.34,33.77,33.77,0,0,0-3.63-.9l-.2,0a40.33,40.33,0,0,0-4.09-.55c-1.36-.12-2.79-.18-4.25-.18h-.09a30.14,30.14,0,0,0-4.53.35,24.34,24.34,0,0,0-4.24,1,22.92,22.92,0,0,0-3.9,1.77,22.3,22.3,0,0,0-3.48,2.49,20.1,20.1,0,0,0-2.89,3,17.5,17.5,0,0,0-2.05,3.5,16.07,16.07,0,0,0-1.12,3.87,17.9,17.9,0,0,0-.14,4.09l2.6,32.92a18.14,18.14,0,0,0,.78,4.05,17.72,17.72,0,0,0,1.68,3.75,19.33,19.33,0,0,0,2.52,3.35,24.34,24.34,0,0,0,3.26,2.91,27.12,27.12,0,0,0,3.77,2.38,26.15,26.15,0,0,0,4.1,1.68,25.79,25.79,0,0,0,2.88.72c.49.1,1,.18,1.48.25a30.47,30.47,0,0,0,4.1.27h.49a30.15,30.15,0,0,0,4.54-.42,24.75,24.75,0,0,0,4.23-1.11,21.82,21.82,0,0,0,3.87-1.84,22.3,22.3,0,0,0,3.45-2.53,21.28,21.28,0,0,0,2.83-3.07,17.42,17.42,0,0,0,2-3.51,16.38,16.38,0,0,0,1.08-3.86,17.64,17.64,0,0,0,.13-4.06l-.88-10.92,0-.46h-.47l-16,.17-6.59-9.42,35.24-.25,1.74,21.2a24.65,24.65,0,0,1-.17,5.72,21.87,21.87,0,0,1-1.45,5.22,23.81,23.81,0,0,1-2.78,4.87,30.84,30.84,0,0,1-4.21,4.59q-.35.32-.69.6l-.69.58-.71.56-.73.54-1.34,1-.22.16,0,.28,4.28,52.62,0,.47.48,0,11.75-.32h.28l.14-.24,25.33-43.73.08-.14v-.15l-7.85-94.27,12.61,0,7.8,92.49-27.27,50.38-.15.28.19.25,32.9,44.31-12.79.52-29.81-40-.16-.21h-.26l-12,.37-.53,0,0,.52,3.33,40.83-11.74.47-7.72-96V203l-.07-.1-.76-1.18-1.57-2.08-.18-.24-.3.05c-.57.09-1.14.18-1.72.25s-1.16.14-1.76.2l-1.81.13c-.61,0-1.23.05-1.85.06h-1a50.15,50.15,0,0,1-6.57-.42c-.86-.12-1.73-.26-2.57-.42a44.37,44.37,0,0,1-4.51-1.13,41.67,41.67,0,0,1-6.57-2.67,43.35,43.35,0,0,1-6.13-3.82,38.15,38.15,0,0,1-5.16-4.6,29.81,29.81,0,0,1-3.75-5,25.86,25.86,0,0,1-2.4-5.35,26.12,26.12,0,0,1-1.11-5.84l-2.57-33.06a24.65,24.65,0,0,1,.2-5.79,21.55,21.55,0,0,1,1.53-5.25,23.54,23.54,0,0,1,2.88-4.86,30.08,30.08,0,0,1,4.33-4.54A34.34,34.34,0,0,1,271,110.89a40.85,40.85,0,0,1,6.73-1.64,48.71,48.71,0,0,1,7.38-.54m0-.5a48.35,48.35,0,0,0-7.45.55,39.75,39.75,0,0,0-6.82,1.66,34.77,34.77,0,0,0-11.59,6.64,30.56,30.56,0,0,0-4.4,4.61,23.55,23.55,0,0,0-2.94,5,22.08,22.08,0,0,0-1.56,5.37,25.06,25.06,0,0,0-.21,5.9L252.75,171a26.66,26.66,0,0,0,1.14,5.95,26.07,26.07,0,0,0,2.44,5.46,30.22,30.22,0,0,0,3.81,5,39.81,39.81,0,0,0,5.23,4.66,43.74,43.74,0,0,0,6.2,3.86,41.88,41.88,0,0,0,6.66,2.71,42.62,42.62,0,0,0,4.55,1.14c.86.16,1.72.31,2.6.42a49.61,49.61,0,0,0,6.64.43h1.05c.63,0,1.25,0,1.87-.06s1.22-.08,1.83-.14,1.19-.11,1.78-.19,1.16-.16,1.73-.26l1.57,2.09.75,1.14,7.75,96.43,12.74-.51-3.37-41.35,12-.37,30,40.17,14-.56-33.46-45.08,27.35-50.5-7.86-93.1-13.62,0,7.9,94.81-25.34,43.73-11.75.33-4.28-52.62,1.33-1,.74-.55.72-.57.71-.59.69-.61a29.89,29.89,0,0,0,4.28-4.67,23.82,23.82,0,0,0,2.84-5,22.76,22.76,0,0,0,1.49-5.34,25.67,25.67,0,0,0,.17-5.84l-1.78-21.65-36.66.25,7.29,10.42,16.23-.17.88,10.92a17.27,17.27,0,0,1-.12,3.95,16,16,0,0,1-1.05,3.74,16.62,16.62,0,0,1-2,3.4,20.3,20.3,0,0,1-2.77,3,22,22,0,0,1-3.36,2.49,23.06,23.06,0,0,1-3.79,1.79,24.75,24.75,0,0,1-4.15,1.09,29,29,0,0,1-4.46.41h-.48a29.43,29.43,0,0,1-4-.27c-.49-.07-1-.15-1.46-.24a25.84,25.84,0,0,1-2.82-.71,24.78,24.78,0,0,1-4-1.65,25.21,25.21,0,0,1-3.7-2.33,24,24,0,0,1-3.2-2.85,19.3,19.3,0,0,1-2.45-3.26,17.3,17.3,0,0,1-1.64-3.65,17.83,17.83,0,0,1-.75-3.94l-2.6-32.92a16.86,16.86,0,0,1,.14-4,15.08,15.08,0,0,1,1.08-3.75,16.51,16.51,0,0,1,2-3.4,20.13,20.13,0,0,1,2.82-3,21.21,21.21,0,0,1,3.4-2.42,22.27,22.27,0,0,1,3.81-1.74,25.3,25.3,0,0,1,4.16-1,30.52,30.52,0,0,1,4.45-.34h.09c1.44,0,2.86.06,4.21.18s2.74.3,4,.54l.19,0a34.87,34.87,0,0,1,3.59.89,30.55,30.55,0,0,1,3.51,1.31,15.55,15.55,0,0,1,3.32,2,13,13,0,0,1,4.27,6.11c.12.35.23.72.32,1.1l14-.06a24.25,24.25,0,0,0-.66-2.51,21.73,21.73,0,0,0-2.32-4.92,22.42,22.42,0,0,0-3.56-4.29,29.36,29.36,0,0,0-4.92-3.72,44.13,44.13,0,0,0-6-3.07,48.32,48.32,0,0,0-6.54-2.21c-1.06-.27-2.15-.52-3.25-.73-1.26-.25-2.56-.45-3.87-.61a64,64,0,0,0-7.71-.46Z",
    transform: "translate(-31.34 -91.12)"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "bp",
    points: "175.23 16.96 190.05 16.99 197.24 110.75 182.34 111.04 175.23 16.96"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "M207.11,108.58l13.82,0L228,201.38l-13.9.26-7-93.06m-.54-.5,7.11,94.07,14.9-.28-7.19-93.77-14.82,0Z",
    transform: "translate(-31.34 -91.12)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "M254.22,300.82a36.68,36.68,0,0,1-10.34-3.66,38.87,38.87,0,0,1-5.78-3.8,36.51,36.51,0,0,1-4.92-4.64,29.93,29.93,0,0,1-3.6-5.08,27.06,27.06,0,0,1-2.33-5.55,30.27,30.27,0,0,1-1.11-6.11l-2.55-33.65a28.63,28.63,0,0,1,.17-6.1,25,25,0,0,1,1.46-5.58,26,26,0,0,1,2.76-5.16,32,32,0,0,1,4.13-4.8,33.43,33.43,0,0,1,5.09-4,32.81,32.81,0,0,1,5.69-2.91,36,36,0,0,1,6.34-1.81,41.64,41.64,0,0,1,7-.7,42.46,42.46,0,0,1,7.11.43c.59.09,1.19.19,1.77.3a39.06,39.06,0,0,1,4.81,1.26,37.53,37.53,0,0,1,6.1,2.68,39.75,39.75,0,0,1,5.67,3.83,36.39,36.39,0,0,1,4.8,4.61,29.71,29.71,0,0,1,3.51,5,27,27,0,0,1,2.29,5.46,28.83,28.83,0,0,1,.88,4l-12.3,6-.31-4a19.17,19.17,0,0,0-.72-3.91,18.3,18.3,0,0,0-1.51-3.63,18.53,18.53,0,0,0-2.29-3.27,22.69,22.69,0,0,0-3-2.87,23.9,23.9,0,0,0-3.49-2.34,22.9,22.9,0,0,0-3.8-1.66,22,22,0,0,0-2.92-.76c-.38-.08-.76-.14-1.15-.2a27.36,27.36,0,0,0-4.28-.25,26.35,26.35,0,0,0-4.25.45,21.3,21.3,0,0,0-4,1.15,20.59,20.59,0,0,0-3.61,1.87,22,22,0,0,0-3.2,2.55,20.2,20.2,0,0,0-2.62,3.08,17,17,0,0,0-1.84,3.47,16.82,16.82,0,0,0-1,3.78,18.21,18.21,0,0,0-.11,4l2.58,33.51a18.35,18.35,0,0,0,.72,4,17.81,17.81,0,0,0,1.53,3.66A19.23,19.23,0,0,0,244,282.7a22.57,22.57,0,0,0,3,2.88,24.11,24.11,0,0,0,3.53,2.32,22.26,22.26,0,0,0,3.83,1.63,21.44,21.44,0,0,0,2.65.68c.48.09,1,.17,1.45.23a26,26,0,0,0,8.56-.31,22.61,22.61,0,0,0,3.95-1.21A20.88,20.88,0,0,0,274.6,287a21.65,21.65,0,0,0,3.18-2.6,19.62,19.62,0,0,0,2.58-3.11,17.34,17.34,0,0,0,1.8-3.47,16.81,16.81,0,0,0,.95-3.77,19.38,19.38,0,0,0,.1-4l-.29-3.6,13.23,5.25a26.68,26.68,0,0,1-.23,4.23,25,25,0,0,1-1.39,5.56,25.82,25.82,0,0,1-2.67,5.16,31.41,31.41,0,0,1-4,4.86,34.2,34.2,0,0,1-5,4.14,33.4,33.4,0,0,1-5.62,3,35.5,35.5,0,0,1-6.3,1.94,42.24,42.24,0,0,1-7,.86,43.15,43.15,0,0,1-7.15-.29c-.85-.11-1.69-.24-2.52-.4Z",
    transform: "translate(-31.34 -91.12)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "M257.14,207.72a42.51,42.51,0,0,1,6.15.43c.58.09,1.17.19,1.75.3a37.93,37.93,0,0,1,4.74,1.24,37.34,37.34,0,0,1,6,2.65,39.68,39.68,0,0,1,5.61,3.78,35.38,35.38,0,0,1,4.73,4.55,29.31,29.31,0,0,1,3.46,4.93,26.76,26.76,0,0,1,2.24,5.36,29.15,29.15,0,0,1,.81,3.58L281.33,240l-.25-3.25a19.81,19.81,0,0,0-.74-4,18.62,18.62,0,0,0-1.55-3.72,19.54,19.54,0,0,0-2.35-3.36,23.09,23.09,0,0,0-3.06-2.93,24.89,24.89,0,0,0-3.56-2.39A23.65,23.65,0,0,0,263,217.9c-.39-.08-.78-.14-1.18-.2a27,27,0,0,0-3.74-.26h-.62a26.46,26.46,0,0,0-4.34.46,22.76,22.76,0,0,0-4.05,1.18,20.81,20.81,0,0,0-3.69,1.91,22.36,22.36,0,0,0-3.28,2.61,21.27,21.27,0,0,0-2.69,3.16,17.34,17.34,0,0,0-2.9,7.46,19.18,19.18,0,0,0-.11,4.09l2.58,33.52a19.29,19.29,0,0,0,.74,4.06,17.81,17.81,0,0,0,1.58,3.77,19.1,19.1,0,0,0,2.38,3.37,22.31,22.31,0,0,0,3.1,2.94,24.82,24.82,0,0,0,3.6,2.37,22.53,22.53,0,0,0,3.92,1.67,24.43,24.43,0,0,0,2.71.69c.48.09,1,.17,1.47.24a26.63,26.63,0,0,0,3.37.21h1a26.29,26.29,0,0,0,4.34-.52,22.54,22.54,0,0,0,4-1.24,21.24,21.24,0,0,0,3.67-2,22,22,0,0,0,3.25-2.65,21.77,21.77,0,0,0,2.65-3.19,17.53,17.53,0,0,0,2.83-7.46,19.65,19.65,0,0,0,.1-4.07l-.23-2.8,12.18,4.83a28.05,28.05,0,0,1-.23,3.83,24.51,24.51,0,0,1-1.37,5.44,25.92,25.92,0,0,1-2.61,5.07,32,32,0,0,1-3.95,4.77,33.23,33.23,0,0,1-4.94,4.08,32.44,32.44,0,0,1-5.53,3,35.6,35.6,0,0,1-6.21,1.92,42.49,42.49,0,0,1-6.95.84c-.61,0-1.23,0-1.83,0a42.62,42.62,0,0,1-5.24-.32c-.83-.11-1.67-.24-2.48-.4a39.45,39.45,0,0,1-4.09-1,36.32,36.32,0,0,1-6.11-2.58,37.48,37.48,0,0,1-5.71-3.76,35.52,35.52,0,0,1-4.86-4.57,28.85,28.85,0,0,1-3.53-5,26.88,26.88,0,0,1-2.29-5.45,29.29,29.29,0,0,1-1.09-6l-2.55-33.65a27.61,27.61,0,0,1,.17-6,24.07,24.07,0,0,1,1.43-5.47,24.46,24.46,0,0,1,2.71-5.05,30.46,30.46,0,0,1,4-4.73,33.82,33.82,0,0,1,5-4,31.42,31.42,0,0,1,5.6-2.86,33.81,33.81,0,0,1,6.24-1.79,40.7,40.7,0,0,1,6.94-.69h.88m0-.5h-.89a41.64,41.64,0,0,0-7,.7,36,36,0,0,0-6.34,1.81,32.81,32.81,0,0,0-5.69,2.91,33.43,33.43,0,0,0-5.09,4,32,32,0,0,0-4.13,4.8,26,26,0,0,0-2.76,5.16,25,25,0,0,0-1.46,5.58,28.63,28.63,0,0,0-.17,6.1L226.14,272a30.27,30.27,0,0,0,1.11,6.11,27.06,27.06,0,0,0,2.33,5.55,29.93,29.93,0,0,0,3.6,5.08,36.51,36.51,0,0,0,4.92,4.64,38.87,38.87,0,0,0,5.78,3.8,36.68,36.68,0,0,0,10.34,3.66h0c.83.16,1.67.29,2.52.4a41.67,41.67,0,0,0,5.3.33c.61,0,1.23,0,1.85,0a42.24,42.24,0,0,0,7-.86,35.5,35.5,0,0,0,6.3-1.94,33.4,33.4,0,0,0,5.62-3,34.2,34.2,0,0,0,5-4.14,31.41,31.41,0,0,0,4-4.86,25.82,25.82,0,0,0,2.67-5.16,25,25,0,0,0,1.39-5.56,26.68,26.68,0,0,0,.23-4.23l-13.23-5.25.29,3.6a19.38,19.38,0,0,1-.1,4,16.81,16.81,0,0,1-.95,3.77,17.34,17.34,0,0,1-1.8,3.47,19.62,19.62,0,0,1-2.58,3.11,21.65,21.65,0,0,1-3.18,2.6,20.88,20.88,0,0,1-3.58,1.92,22.61,22.61,0,0,1-3.95,1.21,26.54,26.54,0,0,1-4.26.51h-1a25.42,25.42,0,0,1-3.3-.21c-.49-.06-1-.14-1.45-.23a21.44,21.44,0,0,1-2.65-.68,22.26,22.26,0,0,1-3.83-1.63,24.11,24.11,0,0,1-3.53-2.32,22.57,22.57,0,0,1-3-2.88,19.23,19.23,0,0,1-2.32-3.29,17.81,17.81,0,0,1-1.53-3.66,18.35,18.35,0,0,1-.72-4l-2.58-33.51a18.21,18.21,0,0,1,.11-4,16.82,16.82,0,0,1,1-3.78,17,17,0,0,1,1.84-3.47,20.2,20.2,0,0,1,2.62-3.08,22,22,0,0,1,3.2-2.55,20.59,20.59,0,0,1,3.61-1.87,21.3,21.3,0,0,1,4-1.15,26.35,26.35,0,0,1,4.25-.45H258a26,26,0,0,1,3.67.25c.39.06.77.12,1.15.2a22,22,0,0,1,2.92.76,22.9,22.9,0,0,1,3.8,1.66,23.9,23.9,0,0,1,3.49,2.34,22.69,22.69,0,0,1,3,2.87,18.53,18.53,0,0,1,2.29,3.27,18.3,18.3,0,0,1,1.51,3.63,19.17,19.17,0,0,1,.72,3.91l.31,4,12.3-6a28.83,28.83,0,0,0-.88-4,27,27,0,0,0-2.29-5.46,29.71,29.71,0,0,0-3.51-5,36.39,36.39,0,0,0-4.8-4.61A39.75,39.75,0,0,0,276,211.9a37.53,37.53,0,0,0-6.1-2.68,39.06,39.06,0,0,0-4.81-1.26c-.58-.11-1.18-.21-1.77-.3a43.48,43.48,0,0,0-6.22-.44Z",
    transform: "translate(-31.34 -91.12)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "M76.5,307.65c-1.25-.24-2.49-.54-3.7-.87a45,45,0,0,1-14-6.68,29.78,29.78,0,0,1-5.06-4.36,16.41,16.41,0,0,1-2.81-4.18,19.55,19.55,0,0,1-1.46-4.82,43.45,43.45,0,0,1-.57-4.52L61.49,274l.24,3.68a17.81,17.81,0,0,0,.78,4.15,16.88,16.88,0,0,0,1.73,3.83A19,19,0,0,0,66.87,289,23.81,23.81,0,0,0,70.31,292a27.43,27.43,0,0,0,4,2.36A28.69,28.69,0,0,0,78.65,296q1.14.31,2.31.54c.76.15,1.54.27,2.33.36a34.1,34.1,0,0,0,4.88.17,32.3,32.3,0,0,0,4.83-.53,28.13,28.13,0,0,0,4.48-1.23,25.34,25.34,0,0,0,7.76-4.6,23.16,23.16,0,0,0,3-3.19,18,18,0,0,0,2.15-3.59,16.1,16.1,0,0,0,1.2-3.95,17.4,17.4,0,0,0,.19-4.16l-4.57-65.72-.17-3.09L99.37,96.35l19.51,10.88L170,181.4,164.58,108l15.16,0,7.31,98.22L227.34,303l-13.15.53L206.9,286.8l-29.76,1.09-7-10.95,32-1.06L180.21,225.7l-13.15,46.48v0l-9.5,33.64-13.86.56,26.05-100.92-52.28-75.76,5.25,74.22.17,3.09,4.85,68.49a26.07,26.07,0,0,1-.27,6.21,24,24,0,0,1-1.72,5.73,27,27,0,0,1-3.22,5.38,34.69,34.69,0,0,1-4.82,5.1,40.29,40.29,0,0,1-6,4.38,42.44,42.44,0,0,1-6.72,3.23,46.84,46.84,0,0,1-7.51,2.09,57.92,57.92,0,0,1-8.35.94,59.09,59.09,0,0,1-8.47-.27C79.26,308.12,77.86,307.91,76.5,307.65Z",
    transform: "translate(-31.34 -91.12)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "bu",
    d: "M99.93,97.24l18.61,10.37,51,74.07,1,1.52-.13-1.84-5.33-72.85,14.16,0,7.27,97.76v.08l0,.07,40,96.08-12.09.49-7.16-16.41-.13-.31h-.34l-29.48,1.08-6.39-10,31.14-1,.74,0-.3-.67L180.67,225.5l-.56-1.28-.38,1.35L166.88,271l0,0-.3,1.06-9.39,33.3-12.83.51,25.89-100.27.05-.22-.13-.19L117.87,129.4l-1-1.51.13,1.82,5.26,74.21.16,3.11,4.86,68.48a26.63,26.63,0,0,1-.27,6.09,24,24,0,0,1-1.69,5.62,26.74,26.74,0,0,1-3.16,5.28,35.26,35.26,0,0,1-4.75,5,40.45,40.45,0,0,1-5.91,4.32,41.13,41.13,0,0,1-6.65,3.19,46.89,46.89,0,0,1-7.43,2.07,57,57,0,0,1-8.27.93c-.81,0-1.63,0-2.43,0a55,55,0,0,1-6-.32c-1.39-.15-2.78-.35-4.12-.61s-2.48-.53-3.67-.87a44.55,44.55,0,0,1-7.21-2.68A46.47,46.47,0,0,1,59,299.69a30,30,0,0,1-5-4.28,16.09,16.09,0,0,1-2.73-4.06,19.59,19.59,0,0,1-1.42-4.7c-.22-1.19-.39-2.52-.54-4.18L61,274.87l.2,2.82A17.8,17.8,0,0,0,62,282a18.12,18.12,0,0,0,1.78,3.94,20,20,0,0,0,2.7,3.48,24.78,24.78,0,0,0,3.51,3,27.78,27.78,0,0,0,8.5,4.07c.77.21,1.56.4,2.34.55s1.58.28,2.37.36a31.45,31.45,0,0,0,3.66.2c.43,0,.87,0,1.3,0A32.36,32.36,0,0,0,93.1,297a28.38,28.38,0,0,0,4.56-1.26,25.75,25.75,0,0,0,4.17-2,24.39,24.39,0,0,0,3.73-2.7,22,22,0,0,0,3.1-3.26,18,18,0,0,0,2.22-3.69,16.68,16.68,0,0,0,1.23-4.06,17.44,17.44,0,0,0,.2-4.29l-4.57-65.7-.17-3.1L99.93,97.24m-.56-.89L107.07,207l.17,3.09,4.57,65.72a17.4,17.4,0,0,1-.19,4.16,16.1,16.1,0,0,1-1.2,3.95,18,18,0,0,1-2.15,3.59,23.16,23.16,0,0,1-3,3.19,25.9,25.9,0,0,1-3.66,2.64,24.87,24.87,0,0,1-4.1,1.95A27.13,27.13,0,0,1,93,296.51a32.3,32.3,0,0,1-4.83.53c-.43,0-.85,0-1.28,0a32.73,32.73,0,0,1-3.6-.19c-.79-.09-1.57-.21-2.33-.36s-1.55-.33-2.31-.54a28.69,28.69,0,0,1-4.34-1.64,27.43,27.43,0,0,1-4-2.36A23.81,23.81,0,0,1,66.87,289a19,19,0,0,1-2.63-3.39,16.88,16.88,0,0,1-1.73-3.83,17.81,17.81,0,0,1-.78-4.15L61.49,274l-12.63,8.24a43.45,43.45,0,0,0,.57,4.52,19.55,19.55,0,0,0,1.46,4.82,16.41,16.41,0,0,0,2.81,4.18,29.78,29.78,0,0,0,5.06,4.36,45,45,0,0,0,14,6.68c1.21.33,2.45.63,3.7.87s2.76.47,4.16.62a56.24,56.24,0,0,0,6,.32c.81,0,1.63,0,2.45,0a57.92,57.92,0,0,0,8.35-.94,46.84,46.84,0,0,0,7.51-2.09,42.44,42.44,0,0,0,6.72-3.23,40.29,40.29,0,0,0,6-4.38,34.69,34.69,0,0,0,4.82-5.1,27,27,0,0,0,3.22-5.38,24,24,0,0,0,1.72-5.73,26.07,26.07,0,0,0,.27-6.21L122.88,207l-.17-3.09-5.25-74.22,52.28,75.76L143.69,306.36l13.86-.56,9.5-33.64v0l13.15-46.48,21.93,50.18-32,1.06,7,10.95,29.76-1.09,7.29,16.72,13.15-.53-40.29-96.74L179.74,108l-15.16,0L170,181.4l-51.07-74.17L99.37,96.35Z",
    transform: "translate(-31.34 -91.12)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.74,309.36l-15.26,4.46q-1.55.45-3.15.81c-1.06.24-2.15.44-3.26.62s-2.24.32-3.38.43-2.32.19-3.51.24a60.49,60.49,0,0,1-8.78-.27,51.16,51.16,0,0,1-8.23-1.55,47.5,47.5,0,0,1-7.66-2.84,49,49,0,0,1-7.08-4.14A32.6,32.6,0,0,1,37,302.41a18.81,18.81,0,0,1-3.24-4.84,22.44,22.44,0,0,1-1.66-5.43,57.53,57.53,0,0,1-.72-6.47l14.46-5a59.26,59.26,0,0,0,.73,6.58,23.2,23.2,0,0,0,1.69,5.52,19.33,19.33,0,0,0,3.29,4.92,32.72,32.72,0,0,0,5.55,4.79,48.73,48.73,0,0,0,7.19,4.21,47.64,47.64,0,0,0,7.77,2.9,51.33,51.33,0,0,0,8.33,1.59,60.86,60.86,0,0,0,8.91.28c1.2-.05,2.39-.13,3.55-.25s2.31-.25,3.43-.43,2.23-.39,3.31-.63S101.69,309.66,102.74,309.36Z",
    transform: "translate(-31.34 -91.12)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "bv"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.74,309.36l-15.26,4.46q-1.55.45-3.15.81c-1.06.24-2.15.44-3.26.62s-2.24.32-3.38.43-2.32.19-3.51.24a60.49,60.49,0,0,1-8.78-.27,51.16,51.16,0,0,1-8.23-1.55,47.5,47.5,0,0,1-7.66-2.84,49,49,0,0,1-7.08-4.14A32.6,32.6,0,0,1,37,302.41a18.81,18.81,0,0,1-3.24-4.84,22.44,22.44,0,0,1-1.66-5.43,57.53,57.53,0,0,1-.72-6.47l14.46-5a59.26,59.26,0,0,0,.73,6.58,23.2,23.2,0,0,0,1.69,5.52,19.33,19.33,0,0,0,3.29,4.92,32.72,32.72,0,0,0,5.55,4.79,48.73,48.73,0,0,0,7.19,4.21,47.64,47.64,0,0,0,7.77,2.9,51.33,51.33,0,0,0,8.33,1.59,60.86,60.86,0,0,0,8.91.28c1.2-.05,2.39-.13,3.55-.25s2.31-.25,3.43-.43,2.23-.39,3.31-.63,2.14-.51,3.19-.81",
    transform: "translate(-31.34 -91.12)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNjMasthead);
export default __webpack_public_path__ + "static/media/NJMasthead.5c32e8817b4f8cec1332974786c20ee6.svg";
export { ForwardRef as ReactComponent };